import React, { useState, useRef } from "react";
import CalendarImg from "assets/icons/calendar.svg";
import "./style.scss";

type Props = {
  title?: string;
  placeholder?: string;
  isAllowed: boolean;
  data: string;
  type?: string;
	updateData: (val: string) => void;
};

export const ProfileInput: React.FC<Props> = ({
  title,
  placeholder,
  isAllowed,
  data,
  type,
	updateData,
}) => {

  return (
    <div className="profile-input-container">
      {title && title !== '' && (<span>{title}</span>)}
      <div className={isAllowed ? 'profile-input' : 'profile-input profile-input-disabled'}>
        <input
          value={data != null ? data : ""}
          type={type ? type : 'text'}
          placeholder={placeholder}
          disabled={!isAllowed}
          onChange={(e) => updateData(e.target.value)}
        ></input>
        {title == "Birth date" && <img src={CalendarImg} alt="calendar" />}
      </div>
    </div>
  );
};
